"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilImplementationRules = exports.HilImplementationRulesReplacementDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const api_delete_js_1 = require("../dtos/api-delete.js");
const merge_values_js_1 = require("../utils/merge-values.js");
const { ImplementationRuleSectionsSchema, RuleCitationSchema, deriveRuleModality, computeImplementationRuleSectionsContentHash, } = cadstrom_shared_1.ImplementationRules;
const hilImplementationRuleDtoSchema = z
    .object({
    text: z.string().optional(),
    citations: RuleCitationSchema.array().min(1).optional(),
    sectionId: z.string().optional(),
})
    .strict();
const hilImplementationRuleCreateDtoSchema = z
    .object({
    text: z.string(),
    citations: RuleCitationSchema.array().min(1),
    sectionId: z.string(),
    ruleRef: z.string().optional(),
})
    .strict()
    .transform(({ ruleRef: _ruleRef, ...value }) => value);
const hilImplementationRuleSectionDtoSchema = z
    .object({
    sectionSlug: z
        .string()
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
        .optional(),
})
    .strict();
const hilImplementationRuleSectionCreateDtoSchema = z
    .object({
    sectionId: z.string(),
    sectionSlug: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
})
    .strict();
const hilImplementationRuleSectionOperationsDtoSchema = z
    .object({
    update: z
        .array(z.object({
        id: z.string(),
        data: hilImplementationRuleSectionDtoSchema.or(api_delete_js_1.ApiDeleteSchema),
    }))
        .optional(),
    create: hilImplementationRuleSectionCreateDtoSchema.array().optional(),
})
    .strict();
const hilImplementationRuleOperationsDtoSchema = z
    .object({
    update: z
        .array(z.object({
        id: z.string(),
        data: hilImplementationRuleDtoSchema.or(api_delete_js_1.ApiDeleteSchema),
    }))
        .optional(),
    create: hilImplementationRuleCreateDtoSchema.array().optional(),
})
    .strict();
const hilImplementationRulesOperatorDtoSchema = z
    .object({
    baseContentHash: z.string(),
    sections: hilImplementationRuleSectionOperationsDtoSchema.optional(),
    rules: hilImplementationRuleOperationsDtoSchema.optional(),
})
    .strict();
exports.HilImplementationRulesReplacementDtoSchema = ImplementationRuleSectionsSchema;
exports.HilImplementationRules = {
    create: (input) => ImplementationRuleSectionsSchema.parse(input),
    merge: async (existing, incoming) => {
        const currentContentHash = await computeImplementationRuleSectionsContentHash(existing);
        if (incoming.baseContentHash !== currentContentHash) {
            throw new Error('The implementation-rules operator update targets a stale editable projection');
        }
        const sectionsWithUpserts = mergeRuleSectionUpserts(existing, incoming.sections);
        const sectionsWithRules = mergeImplementationRules(sectionsWithUpserts, incoming.rules);
        return ImplementationRuleSectionsSchema.parse(deleteRuleSections(sectionsWithRules, incoming.sections));
    },
    schema: ImplementationRuleSectionsSchema,
    dtoSchema: hilImplementationRulesOperatorDtoSchema,
    replacementSchema: exports.HilImplementationRulesReplacementDtoSchema,
};
function mergeRuleSectionUpserts(existing, incoming) {
    const sections = structuredClone(existing);
    for (const update of incoming?.update ?? []) {
        if (update.data === api_delete_js_1.API_DELETE) {
            continue;
        }
        const existingIndex = sections.findIndex((section) => section.sectionId === update.id);
        if (existingIndex === -1) {
            continue;
        }
        const section = sections[existingIndex];
        if (section === undefined) {
            continue;
        }
        sections[existingIndex] = { ...section, sectionSlug: (0, merge_values_js_1.mergeValues)(section.sectionSlug, update.data.sectionSlug) };
    }
    for (const created of incoming?.create ?? []) {
        if (!sections.some((section) => section.sectionId === created.sectionId)) {
            sections.push({ ...created, rules: [] });
        }
    }
    return sections;
}
function deleteRuleSections(sections, incoming) {
    for (const update of incoming?.update ?? []) {
        if (update.data === api_delete_js_1.API_DELETE) {
            const existingIndex = sections.findIndex((section) => section.sectionId === update.id);
            if (existingIndex !== -1) {
                sections.splice(existingIndex, 1);
            }
        }
    }
    return sections;
}
function mergeImplementationRules(sections, incoming) {
    for (const update of incoming?.update ?? []) {
        const location = findRuleLocation(sections, update.id);
        if (location === null) {
            continue;
        }
        if (update.data === api_delete_js_1.API_DELETE) {
            location.section.rules.splice(location.ruleIndex, 1);
            continue;
        }
        const existingRule = location.section.rules[location.ruleIndex];
        if (existingRule === undefined) {
            continue;
        }
        const mergedRule = mergeImplementationRule(existingRule, update.data);
        const targetSectionId = update.data.sectionId ?? location.section.sectionId;
        const targetSection = sections.find((section) => section.sectionId === targetSectionId);
        if (targetSection === undefined) {
            throw new Error(`Implementation-rule section not found: ${targetSectionId}`);
        }
        if (targetSection.sectionId === location.section.sectionId) {
            location.section.rules[location.ruleIndex] = mergedRule;
        }
        else {
            location.section.rules.splice(location.ruleIndex, 1);
            targetSection.rules.push(mergedRule);
        }
    }
    for (const created of incoming?.create ?? []) {
        const section = sections.find((candidate) => candidate.sectionId === created.sectionId);
        if (section === undefined) {
            throw new Error(`Implementation-rule section not found: ${created.sectionId}`);
        }
        section.rules.push(createOperatorRule(created));
    }
    return sections;
}
function findRuleLocation(sections, ruleId) {
    for (const section of sections) {
        const ruleIndex = section.rules.findIndex((rule) => rule.id === ruleId);
        if (ruleIndex !== -1) {
            return { section, ruleIndex };
        }
    }
    return null;
}
function mergeImplementationRule(existing, incoming) {
    const text = (0, merge_values_js_1.mergeValues)(existing.text, incoming.text);
    return {
        ...existing,
        text,
        citations: (0, merge_values_js_1.mergeValues)(existing.citations, incoming.citations),
        modality: requireDerivedRuleModality(text),
    };
}
function createOperatorRule(input) {
    return {
        id: cadstrom_shared_1.ImplementationRules.ImplementationRuleIds.mintOperatorRuleId(),
        text: input.text,
        modality: requireDerivedRuleModality(input.text),
        citations: input.citations,
    };
}
function requireDerivedRuleModality(text) {
    const derivation = deriveRuleModality(text);
    if (derivation.kind !== 'derived') {
        throw new Error('Implementation-rule text must contain a supported modal verb');
    }
    return derivation.modality;
}
//# sourceMappingURL=hil-implementation-rules.js.map